import { render, staticRenderFns } from "./IntegralChange.vue?vue&type=template&id=1cb27ce2&scoped=true"
import script from "./IntegralChange.vue?vue&type=script&lang=js"
export * from "./IntegralChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb27ce2",
  null
  
)

export default component.exports